import React from "react";
import { useTranslation } from 'react-i18next';

export default function (props) {
    const { t } = useTranslation();

  return (
      props.stockItemCode ? (
      <span className="d-block ">
              {t("Article No")}:  {props.stockItemCode}
      </span>
    ) : (
        <span className="d-block">
                  {t("Please select the variation you like from below to view the price.")}
        </span>
      )
  );
}

